import {Button} from '../../../ui/button/button';
import {useDispatch} from 'react-redux';
import { RetouchGetResponse, SimpleRetouchInfo } from '../../../../api/back/retouch/api-retouch';
import { XmlStructureModel } from '../../../../xml/model/xml-structure-model';

export type ParentRetouchInfo = {
  itemId: string,
  productName: string,
  productNameId: string,
  productShortName: string,
  productTypeId: string,
};

export type ChildRetouchInfo = (SimpleRetouchInfo & {selectID: string[]})[]

type Props = {
  callbackSave: () => void,
}
export const ToneCorrectionFooter = (props: Props) => {
  const { callbackSave } = props;
  const dispatch = useDispatch();

  return (
    <div className="print_tone_correction_footer">
      <div className="print_tone_correction_footer__operation">
        <Button
          label="完了"
          onClick={() => callbackSave()}
          size="sm"
        />
      </div>
    </div>
  );
};
